/** The translation for `language`, or the first one there is when that language has none. */
export const translationFor = <T extends { language: string }>(
  translations: readonly T[] | null | undefined,
  language: string | null | undefined,
): T | undefined =>
  translations?.find((translation) => translation.language === language) ??
  translations?.find(Boolean);
